/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Connections_Disconnect_TitleInputs */



/**
* | output |
* | --- |
* | "Disconnect {provider}?" |
*
* @param {Connections_Disconnect_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_disconnect_title = /** @type {((inputs: Connections_Disconnect_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Disconnect_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`${i?.provider} ontkoppelen?`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Déconnecter ${i?.provider} ?`)
	return /** @type {LocalizedString} */ (`Disconnect ${i?.provider}?`)
});